import { ErrorStateMatcher } from '@angular/material/core';
import {
    BooleanFilter,
    DateFilter,
    DateRangeFilter,
    Filter,
    MultilineTextFilter,
    MultiSelectFilter,
    NumberFilter,
    SelectFilter,
    StringFilter,
    TimeFilter,
} from '@models/filter-types';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class FilterInputErrorStateMatcher<T> implements ErrorStateMatcher {
    private interacted = false;

    constructor(
        private property:
            | SelectFilter<T>
            | MultiSelectFilter<T>
            | NumberFilter
            | StringFilter
            | DateFilter
            | DateRangeFilter
            | BooleanFilter
            | TimeFilter
            | MultilineTextFilter
            | Filter<T>,
        private showErrorsAfterInteraction = false,
    ) {}

    isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
        return !this.property?.isValid && (!this.showErrorsAfterInteraction || this.interacted || !!control?.dirty || !!control?.touched);
    }

    markAsInteracted(): void {
        this.interacted = true;
    }

    get validationClass(): 'valid' | 'invalid' {
        return !this.property?.isValid && (!this.showErrorsAfterInteraction || this.interacted) ? 'invalid' : 'valid';
    }
}
